var map = {
	"./8-drunkenBricklayer-pewter/8c491a32-fe4c-4226-8d84-2bb774e34604-700.jpg": 837,
	"./angel/dcac6c49-b276-4cce-a484-21360dbf8614-700.jpg": 847,
	"./assumption-of-the-virgin-mary/1038d114-9c8c-4253-b24d-2475b484b7c8-700.jpg": 857,
	"./banjoVase-cinnamon/455dba73-bf8f-47bc-aadb-1beb6639eb46-700.jpg": 867,
	"./banjoVase-cinnamon/5628c285-b357-46c1-989b-ae5ec614075b-700.jpg": 877,
	"./banjoVase-cinnamon/c3f9b852-6856-439c-8477-566f9ca6acfb-700.jpg": 887,
	"./barkVase-cinnamon/6550197b-f9dd-4cba-be27-0ea4fc7a1cc8-700.jpg": 897,
	"./barkVase-kingfisher/85fbef45-e6e4-4ff4-8c54-d6da547fb25a-700.jpg": 907,
	"./barkVase-ruby/ec6ef8ad-825f-41cb-ae16-f51d3f862163-700.jpg": 917,
	"./barkVase-tangerine/4616ab13-7950-4b3d-9402-02e4f86c441f-700.jpg": 927,
	"./bud-vase-sky-blue/1ac461e3-5be5-478c-ae44-666ad95ee7bb-700.jpg": 937,
	"./decanter-sea-green/9baf2437-bfe5-4bba-bb0b-84aa071d5250-700.jpg": 947,
	"./elephant-amber/55d55b30-4c45-4a8f-9b24-c2d1ad4447d2-700.jpg": 957,
	"./fluted-vase-sky-blue/099e3896-ba41-4a36-b5f1-1abcd3f47199-700.jpg": 967,
	"./good-sheperd/3fbfad3b-a48c-48fd-a9e5-40fe37b5bed3-700.jpg": 977,
	"./hyde-park-chapel-london/e88d3836-d826-40bc-be49-c6de5dfd8c28-700.jpg": 987,
	"./large-fluted-vase-sky-blue/68cf2aca-2c3b-4c72-9e1a-53f99d697752-700.jpg": 997,
	"./nutsNBolts-willow/736b21e1-9987-447e-88f5-65a38eef62e7-700.jpg": 1007,
	"./oval-vase-evening-sky/a45a549b-9648-4f82-805e-51b7954223c9-700.jpg": 1017,
	"./penguin-arctic-blue/2a27b153-f37b-4c53-8085-a421c9223c55-700.jpg": 1027,
	"./plymouth-combined-crown-and-county-courts/1a34e060-9136-4ffd-9f08-e8905869522a-700.jpg": 1037,
	"./plymouth-combined-crown-and-county-courts/f597b0de-f3b2-4ee4-b7a4-2fcab70b28be-700.jpg": 1047,
	"./quatrefoil-st-georges-church/9f004cb1-853d-4d5c-8173-c3a5775565b5-700.jpg": 1057,
	"./sir-hugh-holy-trinity-northwood/197a3067-5a04-4413-9d99-9ff2f72581a2-700.jpg": 1067,
	"./sir-hugh-holy-trinity-northwood/32b3e375-941e-4c75-adab-065c25caa875-700.jpg": 1077,
	"./st-katharines-chapel-window/1446844c-462a-4dba-815d-3a20eeecab55-700.jpg": 1087,
	"./st-katharines-chapel-window/23a3e569-f855-4fcc-9068-d90e827388f4-700.jpg": 1097,
	"./st-katharines-chapel-window/52ea7bc6-3b7f-4c8f-922a-a2d393e5c8c2-700.jpg": 1107,
	"./st-katharines-chapel-window/605b4804-fe48-4a0d-927e-ba92b5ce300e-700.jpg": 1117,
	"./st-margarets-west-hoathy/884230bb-1792-41a4-aff0-4d2e28547d64-700.jpg": 1127,
	"./st-materiana-tintagel/e946fd09-5369-4035-b04a-db100dec1e17-700.jpg": 1137,
	"./st-michael-and-all-angels/45e772ce-a542-41fa-b36e-d4e4a6b268d0-700.jpg": 1147,
	"./st-michael-and-all-angels/8ad241a3-0d13-42c4-80a7-2bb685cfe5c7-700.jpg": 1157,
	"./st-michael-and-all-angels/9ad44424-8f69-42db-95b4-6a99f85605b9-700.jpg": 1167,
	"./st-michael-and-all-angels/d0755079-9a57-478b-a15d-5752ba46bd69-700.jpg": 1177,
	"./st-michael-and-all-angels/ecf43660-b213-4e09-8d49-932a2b985bcb-700.jpg": 1187,
	"./st-nicholas-rotherfield-greys/5b7967ee-0b1e-4c2b-901b-3683b08bc425-700.jpg": 1197,
	"./st-nicholas-rotherfield-greys/63084ff4-80ac-4253-b62b-cc980f4035aa-700.jpg": 1207,
	"./st-pirans-chapel-trevethy-tintagel/7cac0e3e-5645-41a2-8fd3-70bf7cf01c42-700.jpg": 1217,
	"./st-pirans-chapel-trevethy-tintagel/95175420-ded9-4ff2-b34a-56a1b50b7437-700.jpg": 1227,
	"./st-thomas-church-fifth-avenue/5a40b0fe-88e7-481d-bd9c-f60405aa2a3d-700.jpg": 1237,
	"./teardrop-sky-blue/4c73ebfd-62b2-4625-917d-6b39ec26dd19-700.jpg": 1247,
	"./test-tableware/00000000-0000-0000-0000-000000000000-700.jpg": 1257,
	"./test-window/00000000-0000-0000-0000-000000000000-700.jpg": 1267,
	"./tricorn-sky-blue/50a0b4f0-45c6-4d10-b4bb-d93b24b4a9d6-700.jpg": 1277
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1288;



//////////////////
// WEBPACK FOOTER
// ./src/images/objects ^\.\/.*\-700\.jpg$
// module id = 1288
// module chunks = 168707334958949